import type { AnonCartEvent } from "../anon-cart/AnonCartEvents";
import type { CustomerCartEvent } from "../customer-cart/CustomerCartEvents";
import ws from "../../uidispatcherapi/SimpleSocket";
import { url } from "../../utils/UrlUtil";
import * as AnonCartEvents from "../anon-cart/AnonCartEvents";
import * as CustomerCartEvents from "../customer-cart/CustomerCartEvents";
import { trackUiError } from "../../utils/TrackingUtil";
export type AnonCartWebsocketParams = {
	country: string;
	storeId: string;
	anonUserId: string;
};
export type CustomerCartWebsocketParams = {
	customerId: string;
	storeId: string;
	cartId: string;
};
export interface ICartWebsocketConnector<ConnectionParams, Event> {
	connect(
		params: ConnectionParams,
		onMessage: (arg0: Event) => void | Promise<void>,
		onClose: (arg0: ConnectionParams) => void | Promise<void>,
	): void;
	disconnect(): void;
}

class CartWebsocketConnector<ConnectionParams, Event> implements ICartWebsocketConnector<ConnectionParams, Event> {
	_wsConnection:
		| {
				close: () => void;
		  }
		| undefined;
	_getChannel: (arg0: ConnectionParams) => string;
	_noAuth: boolean;
	_transformer: (arg0: Record<string, any>) => Event;

	constructor(params: {
		getChannel: (arg0: ConnectionParams) => string;
		noAuth?: boolean;
		transformer: (arg0: Record<string, any>) => Event;
	}) {
		this._getChannel = params.getChannel;
		this._noAuth = params.noAuth || false;
		this._transformer = params.transformer;
	}

	connect(
		params: ConnectionParams,
		onMessage: (arg0: Event) => void | Promise<void>,
		onClose: (arg0: ConnectionParams) => void | Promise<void>,
	) {
		this.disconnect();

		try {
			this._wsConnection = ws.initConnection({
				channel: this._getChannel(params),
				noAuth: this._noAuth,
				onOpenFailed: () => {
					trackUiError(
						"CartWebsocketConnector",
						`WebSocket could not be opened for ${this._getChannel(params)}.`,
					);
					onClose(params);
				},
				onClose: () => onClose(params),
				onMessage: (json) => onMessage(this._transformer(json)),
			});
		} catch (e) {
			console.warn("Could not connect websocket");
		}
	}

	disconnect() {
		if (this._wsConnection) {
			try {
				this._wsConnection.close();
			} catch (e) {
				console.warn("Could not close websocket");
			}
		}
	}
}

export const AnonCartWebsocketConnector: ICartWebsocketConnector<AnonCartWebsocketParams, AnonCartEvent> =
	new CartWebsocketConnector({
		getChannel: (params) => url`/oc/anon-cart/events/${params.country}/${params.storeId}/${params.anonUserId}`,
		noAuth: true,
		transformer: AnonCartEvents.parseServerEvent,
	});
export const CustomerCartWebsocketConnector: ICartWebsocketConnector<CustomerCartWebsocketParams, CustomerCartEvent> =
	new CartWebsocketConnector({
		getChannel: (params) => url`/oc/customer-carts/events/${params.customerId}/${params.storeId}/${params.cartId}`,
		transformer: CustomerCartEvents.parseServerEvent,
	});
export const SavedCartWebsocketConnector: ICartWebsocketConnector<CustomerCartWebsocketParams, CustomerCartEvent> =
	new CartWebsocketConnector({
		getChannel: (params) => url`/oc/customer-carts/events/${params.customerId}/${params.storeId}/${params.cartId}`,
		transformer: CustomerCartEvents.parseServerEvent,
	});
